import React, { useState, useEffect, useCallback } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { googleDriveService } from '../../services/googleDriveService';
import './cmrStatusModal.css';

const CmrStatusModal = ({
  onClose,
  shipmentNumber,
  formData,
  carrierData,
  handleRequestCMRClick,
}) => {
  const [cmrData, setCmrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const checkCmr = useCallback(async () => {
    setLoading(true);
    setError(null);
    setCmrData(null);

    const result = await googleDriveService.checkShipmentCmr(shipmentNumber);

    if (result.success) {
      setCmrData(result.data);
    } else {
      setError(result.error);
    }

    setLoading(false);
  }, [shipmentNumber]);

  useEffect(() => {
    if (shipmentNumber) {
      checkCmr();
    }
  }, [shipmentNumber, checkCmr]);

  const openCmrInDrive = () => {
    if (cmrData?.exists && cmrData.files.length > 0) {
      const file = cmrData.files[0];
      window.open(file.webViewLink, '_blank', 'noopener,noreferrer');
    }
  };

  const cmrExists = cmrData?.exists && cmrData?.files?.length > 0;
  const file = cmrExists ? cmrData.files[0] : null;

  return (
    <div className="overlay cmr-status-overlay">
      <div className="cmr-status-modal">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>

        <div className="cmr-modal-header">
          <h2 className="cmr-status-title">Statut CMR - Dossier #{shipmentNumber}</h2>
        </div>

        <div className="cmr-status-content">
          {loading && (
            <div className="cmr-status-section">
              <div className="cmr-loading-spinner"></div>
              <p className="cmr-loading-text">Vérification en cours...</p>
            </div>
          )}

          {error && (
            <div className="cmr-status-section">
              <div className="cmr-status-card error">
                <div className="cmr-card-left">
                  <ErrorIcon className="cmr-card-icon" />
                  <div className="cmr-card-content">
                    <h3 className="cmr-card-title">Erreur de connexion</h3>
                    <p className="cmr-card-description">{error}</p>
                  </div>
                </div>
                <button className="cmr-refresh-button" onClick={checkCmr} title="Réessayer">
                  <RefreshIcon />
                </button>
              </div>
            </div>
          )}

          {!loading && !error && cmrData && (
            <>
              <div className="cmr-status-section">
                <div className={`cmr-status-card ${cmrExists ? 'success' : 'warning'}`}>
                  <div className="cmr-card-left">
                    {cmrExists ? (
                      <CheckCircleIcon className="cmr-card-icon" />
                    ) : (
                      <ErrorIcon className="cmr-card-icon" />
                    )}
                    <div className="cmr-card-content">
                      <h3 className="cmr-card-title">
                        {cmrExists ? 'CMR disponible' : 'CMR non trouvée'}
                      </h3>
                      <p className="cmr-card-description">
                        {cmrExists
                          ? 'La CMR est disponible dans Google Drive'
                          : 'Aucune CMR trouvée dans Google Drive'}
                      </p>
                      {file && <p className="cmr-card-filename">{file.name}</p>}
                    </div>
                  </div>
                  {!cmrExists && (
                    <button
                      className="cmr-refresh-button"
                      onClick={checkCmr}
                      title="Actualiser la recherche"
                    >
                      <RefreshIcon />
                    </button>
                  )}
                </div>
              </div>

              <div className="cmr-actions-section">
                {cmrExists ? (
                  <button className="cmr-action-button primary" onClick={openCmrInDrive}>
                    <OpenInNewIcon />
                    <span>Ouvrir dans Google Drive</span>
                  </button>
                ) : (
                  <div className="cmr-request-group">
                    <button
                      className="cmr-action-button primary"
                      onClick={handleRequestCMRClick}
                      disabled={!carrierData?.cmr_email && !formData.carrier_email}
                    >
                      <span>Demander la CMR</span>
                    </button>
                    {carrierData?.cmr_email && (
                      <p className="cmr-info-text">
                        Adresse CMR spécifique : {carrierData.cmr_email}
                      </p>
                    )}
                    {!carrierData?.cmr_email && formData.carrier_email && (
                      <p className="cmr-info-text">Envoi à : {formData.carrier_email}</p>
                    )}
                    {!carrierData?.cmr_email && !formData.carrier_email && (
                      <p className="cmr-warning-text">
                        Aucune adresse email transporteur renseignée
                      </p>
                    )}
                  </div>
                )}
                <button className="cmr-action-button secondary" onClick={onClose}>
                  Fermer
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CmrStatusModal;
